import {
  FETCH_DASHBOARDCOUNT_REQUEST,
    FETCH_DASHBOARDCOUNT_SUCCESS,
    FETCH_DASHBOARDCOUNT_FAILURE,
  } from "./DashboardCountFetchTypes";
  import api from "../../utils/Api";
  
  export const fetchDashboardCountRequest = () => {
    return {
      type: FETCH_DASHBOARDCOUNT_REQUEST,
    };
  };
  
  export const fetchDashboardCountSuccess = (dashboardCounts) => {
    return {
      type: FETCH_DASHBOARDCOUNT_SUCCESS,
      payload: dashboardCounts,
    };
  };
  
  export const fetchDashboardCountFailure = (error) => {
    return {
      type: FETCH_DASHBOARDCOUNT_FAILURE,
      payload: error,
    };
  };
  
  export const fetchDashboardCountData = () => {
    
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    
    return async (dispatch) => {
      dispatch(fetchDashboardCountRequest);
      try {
        const response = await api.get("dashboard",
          {
            headers: headers,
          }
        );
        const dashboardCounts = response.data.data;
        dispatch(fetchDashboardCountSuccess(dashboardCounts));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchDashboardCountFailure(errorMsg));
      }
    };
  };
  